const saveAs = (list, name) => {
  const blob = window.URL.createObjectURL(new Blob(['\uFEFF', list], { type: 'text/csv;charset=utf-8' }));

  const link = document.createElement('a');

  link.download = name;
  link.href = blob;
  link.rel = 'noopener';

  link.dispatchEvent(new MouseEvent('click'));
}

export default saveAs;
